import { APIRoute } from '@/modules/utils'
import { AnimalProfile } from '@/dataV3/Animal/AnimalProfile'

export const Route: APIRoute = {
  method: 'GET',
  path: '/animals/:animalId',
}

export type UrlParams = {
  animalId: string
}

export type Response = AnimalProfile
